import React, { useEffect, useMemo } from 'react';
import BaseChart, { useChartInstance } from '@src/components/common/BaseChart';
import { formatMetricDataForChart } from '../../../utils/format';
import * as Styled from '../styled';

export interface TrendProps {
  data: any[];
  metricKey: string;
  style?: React.CSSProperties;
}

const Trend = ({ data = [], metricKey, style }: TrendProps) => {
  const { instance, chartInstanceRefCb } = useChartInstance({});
  const chartOption = useMemo(
    () => formatMetricDataForChart({ chartData: data, metricKey }),
    [data, metricKey],
  );

  useEffect(() => {
    if (instance) {
      instance.setOption(chartOption);
    }
  }, [instance, chartOption]);

  return (
    <Styled.TrendContainer style={style}>
      <BaseChart
        chartId={`widget-flow-trend-${metricKey}`}
        chartInstanceRefCb={chartInstanceRefCb}
        style={{ height: '100%', width: '100%' }}
      />
    </Styled.TrendContainer>
  );
};

export default React.memo(Trend);
